<template>
  <LayoutDefault>
    СМИ о нас
  </LayoutDefault>
</template>

<script>
import LayoutDefault from '@/layout/LayoutDefault'

export default {
  name: 'MediaEditorView',
  components: {
    LayoutDefault
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
